/**
 * Единое форматирование дат в интерфейсе TEKSHER.
 *
 * Все метки времени в БД (created_at, closed_at, slot_at, ...) хранятся в UTC.
 * В UI показываем их по Москве (UTC+3), вне зависимости от часового пояса
 * браузера пользователя — склад может смотреть с телефона в роуминге, а
 * руководитель из дома: всем нужно одно и то же «московское» время.
 */

const MSK_FMT = new Intl.DateTimeFormat("ru-RU", {
  timeZone: "Europe/Moscow",
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

export function formatMSK(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  // Intl возвращает «21.04.2026, 17:02» — ровно то, что показывается в UI.
  return MSK_FMT.format(d) + " МСК";
}
